import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import MessageBubble from './MessageBubble';
import axios from 'axios';

const ChatBot = ({ setResults }) => {
    const [messages, setMessages] = useState([]);
    const [step, setStep] = useState(0);
    const [typing, setTyping] = useState(false);
    const [answers, setAnswers] = useState({});

    useEffect(() => {
        startConversation();
    }, []);

    const startConversation = () => {
        addBotMessage("Hi there! 👋 What are you looking for?");
    };

    const addBotMessage = (text, delay = 1000) => {
        setTyping(true);
        setTimeout(() => {
            setMessages(prev => [...prev, { sender: 'bot', text }]);
            setTyping(false);
        }, delay);
    };

    const handleAnswer = (text, key, value) => {
        setMessages(prev => [...prev, { sender: 'user', text }]);
        const updated = { ...answers, [key]: value };
        setAnswers(updated);

        if (key === 'lookingFor') {
            setTimeout(() => {
                addBotMessage("Great! Which platform are you interested in?");
                setStep(1);
            }, 800);
        }

        if (key === 'platforms') {
            setTimeout(() => {
                addBotMessage("Awesome! Now choose a category.");
                setStep(2);
            }, 800);
        }

        if (key === 'categories') {
            setTimeout(() => {
                addBotMessage("Searching for influencers…");
                fetchResults(updated.platforms, updated.categories);
            }, 1000);
        }
    };

    const fetchResults = async (platforms, categories) => {
        setTyping(true);
        try {
            const res = await axios.post(process.env.REACT_APP_BASE_URL + `/api/search?page=1`, {
                platforms: [platforms],
                categories: [categories],
            });

            setTimeout(() => {
                setTyping(false);
                setResults(res.data.data);
                addBotMessage("Here are your results!");

                // Reset chat after a short delay
                setTimeout(() => {
                    setMessages([]);
                    setAnswers({});
                    setStep(0);
                    startConversation();
                }, 2000); // Adjust delay as needed
            }, 1500);
        } catch (err) {
            setTyping(false);
            addBotMessage("Oops! Something went wrong.");
        }
    };


    const renderOptions = () => {
        if (step === 0) {
            return (
                <Stack spacing={1}>
                    <Button onClick={() => handleAnswer("Influencers", 'lookingFor', 'Influencers')} variant="contained">Influencers</Button>
                    <Button onClick={() => handleAnswer("Assistance", 'lookingFor', 'Assistance')} variant="outlined">Assistance</Button>
                </Stack>
            );
        }

        if (step === 1) {
            return (
                <Stack spacing={1}>
                    {['Instagram', 'YouTube', 'TikTok', 'Twitter/X', 'Facebook', 'Reddit'].map(p => (
                        <Button key={p} onClick={() => handleAnswer(p, 'platforms', p)} variant="outlined" color="secondary">{p}</Button>
                    ))}
                </Stack>
            );
        }

        if (step === 2) {
            return (
                <Stack spacing={1}>
                    {['Music', 'Fashion', 'Gaming', 'Healthcare', 'Education', 'Travel', 'Comedy', 'Tech'].map(c => (
                        <Button key={c} onClick={() => handleAnswer(c, 'categories', c)} variant="outlined" color="secondary">{c}</Button>
                    ))}
                </Stack>
            );
        }

        return null;
    };

    return (
        <Box>
            {messages.map((msg, idx) => (
                <MessageBubble key={idx} sender={msg.sender} text={msg.text} />
            ))}
            {typing && (
                <MessageBubble sender="bot">
                    <CircularProgress size={16} sx={{ mt: 0.5 }} />
                </MessageBubble>
            )}
            <Box mt={2}>{renderOptions()}</Box>
        </Box>
    );
};

export default ChatBot;
